import React, { useReducer } from 'react';

import SmartLink from 'dpl/components/SmartLink';
import { DELIVERY_PATH } from 'dpl/shared/constants/urls';
import { TRANSPORT_CATEGORY } from 'dpl/breeder_search_results/utils/constants';
import TransportationModal from 'dpl/breeder_search_results/components/TransportationModal';

import { usePuppyData } from '../hooks/usePuppyData';
import Section from './Section';

export default function GettingPuppyHome() {
  const {
    puppy,
    transportation: { categories: transportationCategories },
    breeder
  } = usePuppyData();

  const [isTransportModalOpen, toggleTransportModalOpen] = useReducer(
    isOpen => !isOpen,
    false
  );

  const pickUpTransportation = transportationCategories.find(
    t => t.type === TRANSPORT_CATEGORY.PICKUP
  );
  const dropOffTransportation = transportationCategories.find(
    t => t.type === TRANSPORT_CATEGORY.DROPOFF
  );

  return (
    <Section className="GettingPuppyHome bg-subtle-light-gray">
      <div className="row wider-gutters">
        <div className="col-md-6 mb8">
          <Section.Heading className="mb2">
            Getting {puppy.name} home
          </Section.Heading>
          <Section.Subheading>
            Explore the best option for you.
          </Section.Subheading>
        </div>
        <div className="col-md-6">
          {pickUpTransportation && (
            <div className="pb12">
              <h5 className="heading-5 mb6">Pick up</h5>
              <p className="f3 mb2">{pickUpTransportation.title}</p>
              <p className="secondary mb6">
                {pickUpTransportation.description}
              </p>
              <SmartLink
                to={DELIVERY_PATH}
                className="stone-700 underline"
                target="_blank"
              >
                What to know about bringing a puppy home
              </SmartLink>
            </div>
          )}
          {dropOffTransportation && (
            <div className="pv12 bt b--black-10">
              <h5 className="heading-5 mb6">Drop off</h5>
              <p className="f3 mb2">{dropOffTransportation.title}</p>
              <p className="secondary mb6">
                {dropOffTransportation.description}
              </p>
              <button
                type="button"
                className="stone-700 underline"
                onClick={toggleTransportModalOpen}
              >
                Learn more about your drop off options
              </button>
            </div>
          )}
          {breeder.location &&
            breeder.location.latitude &&
            breeder.location.longitude && (
              <div className="GettingPuppyHome__map mt6-md br3 overflow-hidden">
                <iframe
                  title="breeder-location-map"
                  style={{ border: 0, height: '100%', width: '100%' }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  src={`https://www.google.com/maps/embed/v1/view?key=${CONFIG.googleMapsApiKey}&center=${breeder.location.latitude},${breeder.location.longitude}&zoom=10`}
                />
              </div>
            )}
        </div>
      </div>
      {isTransportModalOpen && (
        <TransportationModal
          breederFirstName={breeder.first_name}
          deliveryMethods={breeder.delivery_methods}
          puppyName={puppy.name}
          onCloseClick={toggleTransportModalOpen}
        />
      )}
    </Section>
  );
}
